exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CampaignListInfluencer .CampaignCard__content__inner {\n  min-height: 200px;\n}\n", ""]);

// exports
